import { Link, graphql, useStaticQuery } from "gatsby";
import React from "react";

export default function Area() {
  const data = useStaticQuery(graphql`
    query AreaQuery {
      allStrapiZona {
        edges {
          node {
            id
            title
            slug
          }
        }
      }
    }
  `);

  return (
    <ul className="flex flex-wrap gap-1">
      {data.allStrapiZona.edges.map((document) => (
        <li
          key={document.node.id}
          className="after:ml-1 after:content-['·'] after:text-amber-300 last-of-type:after:hidden"
        >
          <Link
            to={`/zonas/${document.node.slug}`}
            title={document.node.title}
            className="py-1 inline-block"
          >
            {document.node.title.replace(/Cerramientos en/g, "")}
          </Link>
        </li>
      ))}
    </ul>
  );
}
